import { useDispatch } from 'react-redux';
import { update_id_column } from "../../../../texts/fill";
import { FILTER_IDS_TO_NUMBERS } from "../../../../context/fileReducer";

const UpdateIdColumn = () => {
    const dispatch = useDispatch();
    return (
        <>
            <button
                className="btn btn-success"
                style={{
                    width: '100px',
                    height: '130px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    fontWeight: 600
                }}
                onClick={() => dispatch({
                    type: FILTER_IDS_TO_NUMBERS
                })}
            >
                {update_id_column}
            </button>
        </>
    )
};

export default UpdateIdColumn;